module.exports = __webpack_public_path__ + "static/media/ChangePIN-Flexi.b116f99e.png";